// Claro, oscuro o el del sistema.
//
// POR QUE HAY TRES OPCIONES Y NO UN INTERRUPTOR. «Lo que diga el
// sistema» es lo correcto por omisión —el teléfono del almacén ya cambia
// solo al anochecer— pero no puede ser lo único: el mismo aparato se usa
// en un andén con sol de frente y en una cámara fría a media luz, y ahí
// quien decide es la persona, no el reloj del sistema operativo.
//
// EL ATRIBUTO SE RESUELVE SIEMPRE A UN VALOR CONCRETO. `data-tema` acaba
// siendo «claro» u «oscuro», nunca «sistema»: así el CSS tiene un solo
// selector que mirar en vez de duplicar toda la paleta dentro de una
// media query. Cuando la preferencia es «sistema», este módulo escucha al
// sistema operativo y reescribe el atributo.
const CLAVE = 'tego.tema';
const CONSULTA = '(prefers-color-scheme: dark)';

/** Lo que eligió la persona: 'sistema' | 'claro' | 'oscuro'. */
export function preferencia() {
  try {
    const v = localStorage.getItem(CLAVE);
    return ['claro', 'oscuro'].includes(v) ? v : 'sistema';
  } catch { return 'sistema'; }
}

function delSistema() {
  return window.matchMedia?.(CONSULTA).matches ? 'oscuro' : 'claro';
}

/** El tema que está pintado ahora mismo: 'claro' u 'oscuro'. */
export function vigente() {
  const p = preferencia();
  return p === 'sistema' ? delSistema() : p;
}

// EL COLOR DE LA BARRA DEL SISTEMA SIGUE AL TEMA (DIRECTRIZ-PWA F1, auditoría
// P2-3, 11 oct 2026). index.html trae dos <meta name="theme-color"> —uno para
// el sistema en oscuro y otro claro—, pero el tema aquí lo elige la persona,
// no el sistema: quien pone «oscuro» con el sistema en claro vería la barra
// azul sobre una app oscura. Al pintar se reescriben los dos con el color
// del tema vigente. Claro: la marca (#0067c0, = manifest theme_color).
// Oscuro: el lienzo oscuro (--color-white bajo [data-tema="oscuro"]).
export const COLOR_BARRA = { claro: '#0067c0', oscuro: '#191b20' };

function pintarBarraDelSistema(tema) {
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => {
    m.setAttribute('content', COLOR_BARRA[tema] || COLOR_BARRA.claro);
  });
}

function pintar() {
  const tema = vigente();
  document.documentElement.dataset.tema = tema;
  pintarBarraDelSistema(tema);
}

/** Fija la preferencia y repinta. */
export function elegir(valor) {
  try {
    if (valor === 'sistema') localStorage.removeItem(CLAVE);
    else localStorage.setItem(CLAVE, valor);
  } catch { /* sin almacenamiento: vale para esta sesión */ }
  pintar();
}

/**
 * Arranca el tema. Se llama UNA vez, antes de montar React.
 *
 * Va antes del primer render a propósito: aplicarlo dentro de un efecto
 * pinta la consola en claro durante una fracción de segundo y luego la
 * apaga, que es el destello blanco que molesta justo a quien eligió el
 * modo oscuro.
 */
export function arrancarTema() {
  pintar();
  // Si la preferencia es «sistema», seguir al sistema de verdad: quien lo
  // elige espera que cambie al anochecer sin recargar la página.
  window.matchMedia?.(CONSULTA).addEventListener?.('change', () => {
    if (preferencia() === 'sistema') pintar();
  });
}

/**
 * EL ASPECTO QUE VIAJA CON LA PERSONA · TODO-SIRVE F2-B (30 sep 2026).
 *
 * «Mi cuenta» guardaba el aspecto en el servidor y prometía «se aplica en
 * todos tus aparatos al entrar», pero al entrar nadie lo leía: solo valía
 * en el navegador donde se eligió. `auth.jsx` llama a esto con lo que
 * trae `/auth/yo`. Un valor que no es de los tres no toca nada (servidor
 * anterior, o sin dato). Devuelve true si cambió algo.
 */
export function aplicarAspectoDeLaCuenta(valor) {
  if (!['sistema', 'claro', 'oscuro'].includes(valor)) return false;
  if (valor === preferencia()) return false;
  elegir(valor);
  return true;
}
